import { SessionData } from "../../session/types";
import { isMobile } from "../../utils/browser-support";
import { useIsDcvAllowedByPolicyQuery } from "./useIsDcvAllowedByPolicyQuery";

export function useIsDcvAvailableInSessionQuery(
  session: Pick<SessionData, "streamingGatewayEndpoint">,
) {
  return useIsDcvAllowedByPolicyQuery({
    select: (isDcvAllowed) =>
      isDcvAllowed && !!session.streamingGatewayEndpoint && !isMobile,
  });
}
